import { useEffect, useState } from 'react'
import type { Tone } from './model'
import { bindToast, toast } from './toast'

export function Toast() {
  const [msg, setMsg] = useState('')
  const [on, setOn] = useState(false)
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>
    bindToast((m: string) => {
      setMsg(m)
      setOn(true)
      clearTimeout(timer)
      timer = setTimeout(() => setOn(false), 1900)
    })
    return () => {
      bindToast(null)
      clearTimeout(timer)
    }
  }, [])
  return (
    <div className={`toast${on ? ' on' : ''}`} role="status">
      {msg}
    </div>
  )
}

// --- pill -----------------------------------------------------------
export function Pill({ tone, children }: { tone: Tone; children: React.ReactNode }) {
  return <span className={`pill p-${tone}`}>{children}</span>
}

// --- copy button --------------------------------------------------
export function CopyButton({ value, label = 'copy' }: { value: string; label?: string }) {
  const [done, setDone] = useState(false)
  return (
    <button
      type="button"
      className="cp"
      onClick={(e) => {
        e.stopPropagation()
        navigator.clipboard?.writeText(value).then(
          () => {
            setDone(true)
            toast('Copied')
            setTimeout(() => setDone(false), 1200)
          },
          () => toast('Could not copy'),
        )
      }}
    >
      {done ? 'copied' : label}
    </button>
  )
}
